import React, {useState} from 'react'
import {Button, message, Modal,Form,Input} from "antd";
import {getHostAddress} from "../../Tool/UtileFun"

export function TabButtons(props){



    const [modalStatus,setModalStatus] = useState(false);

    const handleCancel = e => {
        console.log(e);
        setModalStatus(false)
    };

    const showModal = e => {
        console.log(e);
        //console.log("----showModal  getHostAddress-----"+getHostAddress())
        setModalStatus(true)
    };


    const handleOk = e => {
        console.log(e);
        if (inputValue === "" || inputValue === undefined || inputValue===null){
            message.warning("班级名称不得为空！")
            return
        }
        updateClassName()
        setModalStatus(false)
    };

    let inputValue
    const inputChange= e =>{
        inputValue = e.target.value
        console.log(e.target.value)
    }

    const updateClassName=()=>{
        updateClassApi(inputValue)
        RefreshTable()
    }

    const from = (
        <Form>
            <Form.Item label="班级名称"
                       name="name"
            >
                <Input placeholder={props.props.className} onChange={inputChange}/>
            </Form.Item>
        </Form>
    )

    const updateClassApi = (name) =>{
        fetch(
            "http://"+getHostAddress()+"/cclass/updateClass",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify({name:name,id:props.props.id}),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{

            })
            .catch(error => message.error("error"+error));
    }

    const deleteClassApi = () =>{
        fetch(
            "http://"+getHostAddress+"/cclass/deleteClass",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify({id:props.props.id}),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{

            })
            .catch(error => message.error("error"+error));
    }

    const RefreshTable = () =>{
        setTimeout(function () {
            props.Event()
        }, 100);
    }

    const deleteClass = () =>{
        deleteClassApi()
        RefreshTable()
    }

    return(
        <>
            <Button type="primary" onClick={showModal}>编辑</Button>
            <Button type="primary" danger onClick={deleteClass}>删除</Button>
            <Modal
                title="编辑班级"
                visible={modalStatus}
                onOk={handleOk}
                onCancel={handleCancel}
                okText={"确定"}
                cancelText={"取消"}
            >
                {from}
            </Modal>
        </>
    )
}
